<template>
    <tr :style=" show ? 'display:table-row' : 'display:none' ">
        <td :colspan="colgroup.length" style="background-color: #fff">
            <table cellpadding="5" cellspacing="0" border="0" class="table table-shades"
                   style="padding-left:50px;">
                <colgroup>
                    <col class="col-md-020p">
                    <col class="col-md-030p">
                    <col class="col-md-020p">
                    <col class="col-md-030p">
                </colgroup>
                <tbody>

                <template v-for="(datum) in Object.entries(dispay_data)">
                    <div class="col-md-4 col-12">
                        <np-entry :label="lang(datum[0])" :model-value="datum[1]"></np-entry>
                    </div>
                </template>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
    export default {
        name: "np-filter-collapsible-display",
        description: "This component is used to display filter row data in a collapsible block",
        data: function() {
          return {
              show: false
          }
        },
        props: {
            colgroup: {
                type: Array,
                note: 'Column groups'
            },
            dispay_data: {
                type: Object,
                required: true,
                note: 'Data that will be displayed in the collapsible view'
            },
        },
        methods: {
            showCollapsibleBlock(show) {
                this.show = show;
            }
        },
    }
</script>
